import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/var/www/scan.ova-restaurant.com/layouts/default.vue").then(m => m.default || m)),
  "ova-restuarant": defineAsyncComponent(() => import("/var/www/scan.ova-restaurant.com/layouts/ova-restuarant.vue").then(m => m.default || m)),
  wasabi: defineAsyncComponent(() => import("/var/www/scan.ova-restaurant.com/layouts/wasabi.vue").then(m => m.default || m))
}